const baseUrl=process.env.REACT_APP_BASE_URL


export const profileApi={
    forgetPassword:baseUrl+'profile/password/forget',
    getUserDetails:baseUrl+'',
    
}

export const user={
    sendOtp:baseUrl+'auth/sendotp'
}